import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteEventMemberMutationVariables = Types.Exact<{
  input: Types.DeleteEventMemberInput;
}>;

export type DeleteEventMemberMutation = {
  __typename?: 'Mutation';
  deleteEventMember: {
    __typename?: 'DeleteEventMemberResponse';
    message: string;
    success: boolean;
  };
};

export const DeleteEventMemberDocument = gql`
  mutation DeleteEventMember($input: DeleteEventMemberInput!) {
    deleteEventMember(input: $input) {
      message
      success
    }
  }
`;
export type DeleteEventMemberMutationFn = Apollo.MutationFunction<
  DeleteEventMemberMutation,
  DeleteEventMemberMutationVariables
>;
export function useDeleteEventMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEventMemberMutation,
    DeleteEventMemberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEventMemberMutation,
    DeleteEventMemberMutationVariables
  >(DeleteEventMemberDocument, options);
}
export type DeleteEventMemberMutationHookResult = ReturnType<
  typeof useDeleteEventMemberMutation
>;
export type DeleteEventMemberMutationResult =
  Apollo.MutationResult<DeleteEventMemberMutation>;
export type DeleteEventMemberMutationOptions = Apollo.BaseMutationOptions<
  DeleteEventMemberMutation,
  DeleteEventMemberMutationVariables
>;
